angular.module("app").directive("format", [
  "$filter",
  function ($filter) {
    return {
      require: "?ngModel",
      link: function (scope, elem, attrs, ctrl) {
        if (!ctrl) return;

        ctrl.$formatters.unshift(function (a) {
          return $filter(attrs.format)(ctrl.$modelValue);
        });

        ctrl.$parsers.unshift(function (viewValue) {
          switch (attrs.format) {
            case "moeda":
              const prefix =
                angular
                  .element("meta[name=locale-currency-code]")
                  .attr("content") ?? "BRL";

              elem.priceFormat({
                prefix: prefix === "BRL" ? "R$ " : "€ ",
                centsSeparator: ",",
                thousandsSeparator: ".",
                allowNegative: attrs.allowNegative === "true" ? true : false,
              });
              break;
            case "number":
            case "decimal":
              elem.priceFormat({
                prefix: "",
                centsSeparator: ",",
                thousandsSeparator: ".",
              });
              break;
            case "integer":
              elem.priceFormat({
                prefix: "",
                centsSeparator: "",
                thousandsSeparator: "",
                centsLimit: 0,
              });
              break;
            case "percentual":
              elem.priceFormat({
                prefix: "",
                centsSeparator: ",",
                thousandsSeparator: ".",
                clearPrefix: true,
              });
              break;
          }

          return elem[0].value;
        });
      },
    };
  },
]);
angular.module("app").directive("convertToNumber", function () {
  return {
    require: "ngModel",
    link: function (scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function (val) {
        return parseInt(val, 10);
      });
      ngModel.$formatters.push(function (val) {
        if (typeof val == "undefined" || val === null) return null;
        return "" + val;
      });
    },
  };
});

angular.module("datetimepicker", []).directive("datetimepicker", function () {
  return {
    restrict: "A",
    require: "ngModel",
    scope: {
      ngModel: "=",
    },
    link: function (scope, element, attrs, ctrl) {
      var config = { format: "DD/MM/YYYY HH:mm", locale: "pt-br" };
      var userConfig = angular.fromJson("{" + attrs.datetimepicker + "}");
      config = angular.extend(config, userConfig);

      scope.$watch(
        function () {
          return ctrl.$viewValue;
        },
        function (newValue, oldValue) {
          const testDate = moment(newValue, config.format);
          const formatoOk = newValue === testDate.format(config.format);

          if (formatoOk) {
            scope.ngModel = newValue;
          }
        }
      );

      element.datetimepicker(config);

      if (element.find("input")) input = element.find("input");
      else input = element;

      var picker = element.data("DateTimePicker");

      ctrl.$formatters.push(function (value) {
        return value ? value : "";
      });

      element.find("input").on("keyup change blur", function (e) {
        scope.$apply(function () {
          ctrl.$setViewValue(element.find("input").val());
        });
      });

      element.on("dp.change dp.hide change", function (e) {
        scope.$apply(function () {
          if (e.date) {
            ctrl.$setValidity("datetime", true);
            ctrl.$setViewValue(e.date.format(config.format));
          }
        });
      });
    },
  };
});

angular.module("app").directive("capitalize", function () {
  return {
    require: "ngModel",
    link: function (scope, element, attrs, modelCtrl) {
      var capitalize = function (inputValue) {
        if (inputValue == undefined) inputValue = "";
        var capitalized = inputValue.toUpperCase();
        if (capitalized !== inputValue) {
          modelCtrl.$setViewValue(capitalized);
          modelCtrl.$render();
        }
        return capitalized;
      };
      modelCtrl.$parsers.push(capitalize);
      capitalize(scope[attrs.ngModel]); // capitalize initial value
    },
  };
});

angular.module("app").directive("modalFooterFlutuante", function () {
  return {
    restrict: "A",
    link: function (scope, element, attrs, ngModel) {
      /* Fazer o footer ficar sempre visível, independente do tamanho do scroll
       **/

      $(element).closest(".modal").css("overflow-y", "scroll");

      $(element).parent().find("modal-body").css("margin-bottom", "70px");

      $(element)
        .closest(".modal")
        .scroll(function () {
          var hModal = $(element).closest(".modal").height();
          var hElement = $(element).outerHeight();
          var scrollTop = $(this).scrollTop();
          var modalBodyOffsettop = $(this).find(".modal-body")[0].offsetTop;
          var top = hModal + scrollTop - hElement - modalBodyOffsettop + 27;

          $(this)
            .find(".modal-body")
            .css("padding-bottom", $(element).height() + 5);

          if (
            $(window).width() > 768 &&
            $(this).find(".modal-content").height() >
              $(this).height() - modalBodyOffsettop
          ) {
            $(element).css("position", "fixed");
            $(element).css("top", top);
            $(element).css("background-color", "#fff");
            $(element).css("width", "100%");
          } else {
            $(element)[0].style.removeProperty("position");
            $(element)[0].style.removeProperty("top");
            $(element)[0].style.removeProperty("background-color");
            $(element)[0].style.removeProperty("width");
          }
        });

      //Ao mudar de aba, recalcular
      $(element)
        .closest(".modal")
        .on("shown.bs.tab", 'a[data-toggle="tab"]', function (e) {
          $(element).closest(".modal").scroll();
        });

      //Ao iniciar, recalcular
      $(element)
        .closest(".modal")
        .on("shown.bs.modal", function (e) {
          $(element).closest(".modal").scroll();
        });

      $(window).resize(function () {
        $(element).closest(".modal").scroll();
      });

      var modalHeight = $(element)
        .closest(".modal")
        .find(".modal-body")
        .height();
      setInterval(function () {
        if (
          modalHeight !=
          $(element).closest(".modal").find(".modal-body").height()
        ) {
          modalHeight = $(element)
            .closest(".modal")
            .find(".modal-body")
            .height();
          $(element).closest(".modal").scroll();
        }
      }, 100);
    },
  };
});

angular.module("app").directive("toggleButton", function () {
  return {
    restrict: "A",
    transclude: true,
    replace: false,
    require: "ngModel",
    link: function ($scope, $element, $attr, require) {
      var ngModel = require;
      // update model from Element
      var updateModelFromElement = function () {
        // If modified
        var checked = $element.prop("checked");
        if (checked != ngModel.$viewValue) {
          // Update ngModel
          ngModel.$setViewValue(checked);
          $scope.$apply();
        }
      };

      // Update input from Model
      var updateElementFromModel = function () {
        // Update button state to match model
        $element.trigger("change");
      };

      // Observe: Element changes affect Model
      $element.on("change", function () {
        updateModelFromElement();
      });

      // Observe: ngModel for changes
      $scope.$watch(
        function () {
          return ngModel.$viewValue;
        },
        function () {
          updateElementFromModel();
        }
      );

      // Initialise BootstrapToggle
      $element.bootstrapToggle();
    },
  };
});
